import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Link from 'react-router/lib/Link'
import Table from 'react-bootstrap/lib/Table'
import ListGroup from 'react-bootstrap/lib/ListGroup'
import Icon from 'react-icons/lib/md/search'
import trim from 'validator/lib/trim'
import Bullet from 'react-icons/lib/md/adjust'
import acc from 'accounting'

import FormModal from 'components/FormModal'
import { searchPayment } from 'containers/Payments/actions'

class SearchModalPayment extends Component {

  componentDidMount() {
    setTimeout(() => {
      this._focus.select()
    }, 0)
  }

  _onSubmit = (e) => {
    e.preventDefault()

    const value = trim(this._focus.value)

    if (value === '') {
      return
    }

    this.props.dispatch(searchPayment(value))
  }

  _renderForm() {
    return (
      <form className="search-form" onSubmit={this._onSubmit}>
        <div>
          <input
            type="text"
            ref={c => this._focus = c}
            className="form-control"
            placeholder="Search Payment by OR or Payee"
          />
          <div className="add-on"><Icon /></div>
        </div>
      </form>
    )
  }

  _renderResults() {
    const { __results } = this.props

    if (!__results || __results.size === 0) {
      return null
    }


    return (
      <ListGroup fill>
        {__results.map((item) => (
          <Link
            to={`/payments/${item.get('id')}`}
            key={item.get('id')}
            // onClick={onSelectItem.bind(this, item)}
            className="list-group-item"
          >
            <Table hover condensed>
              <tbody>
                <tr>
                  <td width="5%"><span className="btn-icon btn-inline"><Bullet /></span></td>
                  <td width="15%"><small className="text-primary">{item.get('orno')}</small></td>
                  <td width="40%">{item.get('payee')}</td>
                  <td width="20%"><small>{item.get('paydate')}</small></td>
                  <td width="20%" className="text-right"><strong>{acc.formatNumber(item.get('amount'), 2)}</strong></td>
                </tr>
              </tbody>
            </Table>
          </Link>
        ))}
      </ListGroup>
    )
  }

  render() {
    const { handleClose } = this.props
    return (
      <FormModal handleClose={handleClose}>
        <div className="search-modal">
          {this._renderForm()}
          {this._renderResults()}
        </div>
      </FormModal>
    )
  }
}

SearchModalPayment.propTypes = {
  __results: PropTypes.object,
  onSelectItem: PropTypes.func,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __results: state.payment.get('searchResults'),
  }
}

export default connect(mapStateToProps)(SearchModalPayment)



// WEBPACK FOOTER //
// ./src/components/SearchModalPayment/index.js